import  { HANDLE_DOCUMENTATION, RESET } from "../actions";

const initialState = {
    search: "",
    documentation: [],
    page: 1
};

const Report = (state = initialState, action) => {
    switch(action.type) {
        case HANDLE_DOCUMENTATION : 
            return {
                ...state,
                ...action.data
            }
        case RESET :
            return initialState
        default:
            return state;
    }
}

export default Report;